export const characterArray = (code?: string): string[] =>
  code?.split('') ?? [];
